// @ts-nocheck
/* eslint-disable */
import ParamsItemDatetime from "./item.datetime";
import ParamsItemPubtSelect from "./item.pubtselect";
import ParamsItemSelect from "./item.select";
import ParamsItemToll from "./item.toll";
import ParamsItemPUBT from "~/route4/params/item.pubt";
import ParamsCarOptions from "./item.car.options";
import { icon, node } from "~/util/dom";
import Tooltip from "~/ui/tooltip";
import { _ } from "~/route/globals";
import { ROUTE_CONST } from "~/route/const";

export default class ParamsItem {
	constructor(type, circuit = false) {
		this._type = JSON.parse(JSON.stringify(type));
		this._useTraffic = false;
		this._circuit = circuit;
		this._button = node("button", { type: "button" });
		this._button.appendChild(icon(type.svg, type.name));
		this._container = node("div", { className: "hide item-type-params" });

		if (type.type === ROUTE_CONST.TYPE_CAR) {
			this._container.classList.add("car");
		}

		if (Mapy.CUS.route?.anotherCriterion) {
			this._container.classList.add("new-route-types");
		}

		this._subitems = [];
		this._lids = [];
		this._tooltip = null;

		if (type.beta) {
			this._button.classList.add("beta");
		}

		if (type.subItems && type.subItems.length) {
			this._buildSubitems(type.subItems);
		}

		this._button.addEventListener("click", this);

		this._setListeners();
	}

	destroy() {
		Mapy.CML.removeListeners(this._lids);
		this._button.removeEventListener("click", this);
		this._type.subItems.forEach((si, i) => {
			switch(si.type) {
				case "radio":
				case "toll":
					this._subitems[i].input.removeEventListener("change", this);
					break;
			}
			si.destroy();
		});
	}

	get container() {
		return this._container;
	}

	get button() {
		return this._button;
	}

	set state(state) {
		let c = state.criterion;
		const traffic = !!state.useTraffic;
		const departure = state.departure;
		const datetime = state.datetime;
		const allowViaFerrata = state.allowViaFerrata;

		if (this._subitems.length) {
			let checked = this._setCriterion(c, traffic, departure, datetime, allowViaFerrata);

			if (!checked) {
				let constant = [];
				let params = [];

				this._type.subItems.forEach((si, i) => {
					if (si.constant) {
						constant.push([si, this._subitems[i]])
					}
					if (si.param) {
						params.push([si, this._subitems[i]]);
					}
				});

				if (constant.length) {
					c -= constant[0][0].constant;
					this._setCriterion(c, traffic, departure, datetime, allowViaFerrata);
					constant[0][1].input.checked = true;
				}
				else if (params.length) {
					params.forEach(p => {
						let item = p[0];
						if (item.param in state) {
							if ("paramValue" in item && item.paramValue == state[item.param]) {
								p[1].input.checked = true;
							}

							if (!item.paramValue) {
								p[1].state = state[item.param];
							}
						}
					});
				}
			}
		}
	}

	handleEvent(e) {
		if (this._button.classList.contains("deactive")) {
			return;
		}

		if (e.target == this._button || this._button.contains(e.target)) {
			const params = {
				avoidHighways: false,
				allowViaFerrata: false,
			};

			if (this._circuit) {
				params.tripCriterion = this._type.def;
				params.tripIndex = 0;
			}
			else {
				params.criterion = this._type.def;
			}

			const isNewTypeCar = ROUTE_CONST.types.car.type == this._type.type;

			params.type = this._type.type;
			params.useTraffic = this._useTraffic || isNewTypeCar;

			Mapy.CML.state = {
				route: {
					params,
					routeWaypoints: "",
					zoom: true
				}
			};

			// zapomeneme, ze uz videl navrzeny mapset
			try {
				sessionStorage.removeItem("suggestMap");
			} catch(ex) {}

			Mapy.getComponent("history").save();
		}
		else {
			this._paramsChange();
		}
	}

	_buildSubitems(subItems) {
		subItems.forEach((si, i) => {
			let item = null;

			switch(si.type) {
				case "radio":
					item = Mapy.Util.buildRadioCheck("radio", si.name || "", si.label);
					if (si.checked) {
						item.input.checked = true;
					}
					item.input.addEventListener("change", this);
					break;

				case "checkbox":
					item = Mapy.Util.buildRadioCheck("checkbox", si.name || "", si.label);
					if (si.checked) {
						item.input.checked = true;
					}
					if (si.value){
						item.input.value = si.value;
					}
					item.input.addEventListener("change", this);
					break;

				case "toll":
					item = new ParamsItemToll(si);
					item.input.addEventListener("toll-change", this);
					break;

				case "datetime":
					item = new ParamsItemDatetime(si);
					item.input.addEventListener("pubt-datetime-change", this);
					break;

				case "select":
					item = new ParamsItemSelect(si);
					item.input.addEventListener("params-select-change", this);
					break;

				case "pubtSelect":
					item = new ParamsItemPubtSelect(si);
					item.input.addEventListener("params-pubtselect-change", this);
					break;

				case "pubt":
					item = new ParamsItemPUBT(si);
					item.input.addEventListener("params-pubt-change", this);
					break;

				case "car-options":
					item = new ParamsCarOptions(si);
					item.input.addEventListener("params-car-options-change", this);
					break;
			}

			if (item) {
				if (item.state && item.state) {
					this._useTraffic = !!item.state.useTraffic;
				}

				if (item.label) {
					item.label.appendChild(item.input);
					item.label.appendChild(item.title);
					this._container.appendChild(item.label);
				}
				else {
					this._container.appendChild(item.input);
				}

				this._subitems.push(item);
			}
		});
	}

	_toggleContainer(show) {
		this._container.classList[show ? "remove" : "add"]("hide");
		this._button.classList[show ? "add" : "remove"]("active");
	}

	_setListeners() {
		let checkChange = state => {
			if (state.route.items.length == 1 && state.route.items[0].planTrip) {
				if (this._circuit && this._type.criterion.indexOf(state.route.params.tripCriterion) > -1) {
					this._toggleContainer(true);

					this.state = state.route.params;
				}
				else {
					this._toggleContainer(false);
				}
			}
			else if (this._type.criterion.indexOf(state.route.params.criterion) > -1) {
				this._toggleContainer(true);

				this.state = state.route.params;
			}
			else {
				this._toggleContainer(false);
			}
		};

		this._lids = [
			Mapy.CML.addListener((params, state, fromRestore) => {
				if (fromRestore) return;
				checkChange(state);
			}, "route.params"),
			Mapy.CML.addListener((items, state, fromRestore) => {
				if (fromRestore) return;
				checkChange(state);
			}, "route.items"),
			Mapy.CML.addListener((clear, state, fromRestore) => {
				for (let t in ROUTE_CONST.types) {
					if (ROUTE_CONST.types[t].type == this._type.type) {
						this._type.def = ROUTE_CONST.types[t].def;
					}
				}
			}, "route.clear"),
			Mapy.CML.addListener(criterions => {
				const active = this._type.criterion.some(typeCriterion => criterions.indexOf(typeCriterion) > -1)
				this._button.classList[active ? "remove" : "add"]("deactive");

				if (!this._tooltip && !active) {
					this._tooltip = new Tooltip({
						anchor: this._button,
						trigger: this._button,
						content: node("p", {}, _(`route.form.button.deactive.${this._type.type}`)),
						offset: [4, 0, 4, 0],
						hideTimeout: 0,
						width: 208,
						...Mapy.Util.isMobile() ? { triggerEventType: "click" } : {},
					});
				} else if (active && this._tooltip) {
					this._tooltip.hide();
					this._tooltip.destroy();
					this._tooltip = null;
				}
			}, "route.validCriterions"),
		];
	}

	_setCriterion(c, traffic, departure, datetime, allowViaFerrata) {
		let checked = false;
		let criterion = c;

		this._type.subItems && this._type.subItems.forEach((si, i) => {
			if (si.type === "select") {
				if (ROUTE_CONST.TYPE_CAR_AVOID_TOLL_CRITERIONS.includes(criterion)) {
					criterion--;
				}

				// bude zaskrtnuto, pokud najdeme neco, cehoz hodnota odpovida te stavajici
				const index = si.items.map(item => item.value).findIndex(value =>
					typeof value == "object"
						? value[si.variable] == criterion && !!value.useTraffic == traffic
						: value == (si.variable == "departure" ? departure : criterion)
				);

				if (index != -1) {
					if (si.variable != "departure") {
						checked = true;
					}

					const incInd = ROUTE_CONST.types.trial.type == this._type.type && allowViaFerrata
						? 1
						: 0;

					this._subitems[i].selectItem(index + incInd);
				}
			} else if (si.type === "pubtSelect") {
				this._subitems[i].state = criterion;
			} else if (si.type === "datetime") {
				this._subitems[i].state = datetime;
			} else if (si.type === "pubt") {
				this._subitems[i].state = {
					datetime,
					departure,
					flags: [],
				};
			} else {
				if (si.c && si.c == criterion) {
					this._subitems[i].input.checked = true;
					checked = true;
				}
			}
		});

		return checked;
	}

	_paramsChange() {
		let params = {
			criterion: this._type.def,
			useTraffic: false,
			allowViaFerrata: false,
		};

		if (this._type.subItems && this._type.subItems.length) {
			this._type.subItems.forEach((si, i) => {
				switch(si.type) {
					case "radio":
						if (this._subitems[i].input.checked) {
							if (this._type.subItems[i].c) {
								params.criterion = this._type.subItems[i].c;
							}
							else if (this._type.subItems[i].param) {
								params[this._type.subItems[i].param] = this._type.subItems[i].paramValue;
							}
						}
						break;

					case "toll":
						if (this._subitems[i].input.checked) {
							params.criterion += this._type.subItems[i].constant;
						}

						params.excludeCountries = this._subitems[i].avoidAll ? [] : this._subitems[i].excludeCountries;
						break;

					case "datetime":
						let dateTime = this._subitems[i].date;

						if (dateTime) {
							params.datetime = Mapy.Util.dateToISO(dateTime);
						}
						else {
							params.datetime = "";
						}

						Mapy.CML.state = {
							route: {
								pubtIndex: []
							}
						};

						break;

					case "select":
						if (typeof this._subitems[i].state === "number" || typeof this._subitems[i].state === "boolean") {
							params[si.variable] = this._subitems[i].state;
						} else {
							params[si.variable] = this._subitems[i].state.criterion;
							params.useTraffic = !!this._subitems[i].state.useTraffic;
							params.allowViaFerrata = !!this._subitems[i].state.allowViaFerrata;
							this._useTraffic = params.useTraffic;
						}
						break;

					case "pubtSelect":
						params.criterion = this._subitems[i].state;
						break;

					case "pubt":
						Mapy.CML.state = {
							route: {
								pubtIndex: [],
							},
						};

						const siState = this._subitems[i].state;

						params.datetime = siState.datetime;
						params.departure = siState.departure;

						break;

					case "car-options": {
						const state = this._subitems[i].state;

						if (state.avoidToll) {
							params.criterion++;
						}

						delete state.avoidToll;

						Object.assign(params, state);
						break;
					}
				}
			});
		}

		params.type = this._type.type;

		Mapy.CML.state = {
			route: {
				params,
				routeWaypoints: "",
				zoom: true
			}
		};

		this._type.def = params.criterion;
	}
}
